import { dFlex } from '@assets/mixins';

export const boxWithHashLinkStyles = {
  ...dFlex('space-between', 'center'),
  width: '100%',
};

export const boxStyles = {
  ...dFlex('space-between', 'flex-start'),
};
